// extracted by mini-css-extract-plugin
export default {"bg_start_page":"start-page_bg_start_page__12s3q","title":"start-page_title__O6n0S","video_bg":"start-page_video_bg__33Yu4"};